import * as z from "zod";

export const setOkendoMarketingIntegration = {
  name: "setOkendoMarketingIntegration" as const,
  input: z.object({ okendoUserId: z.string(), apiKey: z.string() }),
  output: z.null(),
};

export type SetOkendoMarketingIntegrationInput = z.infer<
  typeof setOkendoMarketingIntegration.input
>;
